import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Popup, Icon} from 'semantic-ui-react';

const EditIcon = ({group}) => {
  const [isOpen, setIsOpen] = useState(false);
  const path = `/grupo-de-correo/editar/${group}`;

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Popup
      inverted
      on="click"
      content="Editar"
      position="top center"
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      trigger={
        <Link to={path}>
          <Icon name="write" color="red" size="big" />
        </Link>
      }
    ></Popup>
  );
};

export default EditIcon;
